import React from 'react';
import { useTranslation } from 'react-i18next';

const Loading = () => {
  const { t } = useTranslation();
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
      <div className="text-center">
        <div className="spinner-border spinner-border-sm text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">{t('common.loading')}</span>
        </div>
        <p className="mt-3 text-muted">{t('common.loading')}</p>
      </div>
    </div>
  );
};

export default Loading;
